import { render, staticRenderFns } from "./Bitrix24Callback.vue?vue&type=template&id=433169fc&scoped=true&"
import script from "./Bitrix24Callback.vue?vue&type=script&lang=ts&"
export * from "./Bitrix24Callback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433169fc",
  null
  
)

export default component.exports